import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  private redirect: string;
  private errorMsg: string;

  constructor() { }

  public setRedirect(res: string) {
    this.redirect = res;
  }

  public getRedirect() {
    return this.redirect;
  }

  public setErrorMsg(msg: string) {
    this.errorMsg = msg;
  }

  public getErrorMsg() {
    return this.errorMsg;
  }

}
